import { useCallback, useState } from 'react';
import ModalComponent from '../Modal/ModalComponent';
import ReceptionPhoto from '../ReceptionPhoto/ReceptionPhoto';
import './SearchCondoUser.css';
import AsyncSelect from "react-select/async";
import { debounce, wait } from '../../utils/timer';
import CondoUserService from '../../services/CondoUserService';
import Button from '../Button/Button';
import { UserSearch } from 'lucide-react';
import { useUserStore } from '../../contexts/userStore';
import { NotificationManager } from 'react-notifications';
import { useNavigate } from 'react-router-dom';
import EventsService from '../../services/EventsService';
import { formatDate, formatRelativeDate } from '../../utils/date';
import { useAuth } from '../../contexts/auth';
import { useTranslation } from 'react-i18next';
import { useFastCondoUserStore } from '../../views/CondoUsers/FastFormCondoUserModal/context';
import { RxEnter } from 'react-icons/rx';
import { PiUserList } from 'react-icons/pi';

const SearchCondoUser = () => {
   const { t } = useTranslation();

   const [modalSearchUser, setModalSearchUser] = useState(false);
   const [optionsSelectCondoUsers, setOptionsSelectCondoUsers] = useState([]);
   const [selectedCondoUser, setSelectedCondoUser] = useState();
   const { selectedCondominio } = useUserStore();
   const navigate = useNavigate();
   const { user } = useAuth();
   const [modalUserDetail, setModalUserDetail] = useState(false);
   const [userPresence, setUserPresence] = useState(null);
   const { findUserByUuid, update } = useFastCondoUserStore();

   const handleConfirm = (modalType) => {
      if (!selectedCondoUser) {
         NotificationManager.error("", "Informe um usuário", 5000, () => {
            alert("callback");
         });
         return;
      }
      setModalSearchUser(false);
      setModalUserDetail(false);
      setSelectedCondoUser(null);
      setUserPresence(null);
      if (modalType === "searchUser") {
         navigate("/cadastro-condo-users", { state: selectedCondoUser });
      }
   };

   const handleCancel = (modalType) => {
      setModalSearchUser(false);
      setModalUserDetail(false);
      setSelectedCondoUser(null);
      setUserPresence(null);
   };

   const promiseUserOptions = async (inputValue) =>
      new Promise(async (resolve) => {
         const usersResponse = await CondoUserService.listCondoUsersByCondoPaginated(
            1,
            inputValue,
            user.userData.selectedOrganizationId,
            { collumnTitle: "createdAt", orderDirection: "DESC" },
            null,
            selectedCondominio
         );
         setOptionsSelectCondoUsers(usersResponse.data?.items);

         const transformedData = usersResponse.data?.items?.map((item) => ({
            value: item.id,
            label: item.name,
         }));

         resolve(transformedData);
      });

   const fetchUsersDebounce = useCallback(
      debounce(promiseUserOptions, 700), []
   );

   async function fetchUserPresence(uuid) {
      const presenceResponse = await EventsService.getPresenceUser(uuid, selectedCondominio);
      setUserPresence({
         text: presenceResponse.data?.last_destiny ?? 'Ausente',
         date: presenceResponse.data?.entry_date ? new Date(presenceResponse.data?.entry_date) : null
      });
   }

   const handleUserSelect = (selectedOption) => {
      setUserPresence(null);
      const userSelected = optionsSelectCondoUsers.find((user) => {
         return user.id === selectedOption.value;
      });
      setSelectedCondoUser(userSelected);
      fetchUserPresence(userSelected.uuid);
   };

   return (
      <>
         <Button
            className={"button-blue reception-button"}
            label={t("monitoring.findUser")}
            onClick={() => setModalSearchUser(true)}
            icon={<UserSearch size={17} />}
         />
         <ModalComponent
            modalIsOpen={modalSearchUser}
            modalText={(
               <h3 className='inline-flex flex-row items-center justify-center gap-2'>
                  <UserSearch size={18} />
                  {t("monitoring.findUser")}
               </h3>
            )}
            hideConfirmButton={true}
            hideCancelButton={true}
            customButtons={(
               <>
                  <Button
                     onClick={(e) => {
                        (async () => {
                           update("open", true);
                           await wait(100);
                           findUserByUuid(selectedCondoUser.uuid);
                           handleCancel("searchUser");
                        })();
                     }}
                     disabled={!selectedCondoUser}
                     icon={<RxEnter size={18} />}
                     label={"Novo acesso"}
                  />
                  <Button
                     onClick={() => handleConfirm("searchUser")}
                     icon={<PiUserList size={18} />}
                     disabled={!selectedCondoUser}
                     label={"Mais detalhes"}
                  />
                  <Button
                     className={"button-white"}
                     onClick={() => handleCancel("searchUser")}
                     label={t("common.close")}
                  />
               </>
            )}
         >
            <div style={{ height: "70px" }}>
               <AsyncSelect
                  className="basic-single reception-search-user-select"
                  cacheOptions
                  defaultOptions
                  loadOptions={fetchUsersDebounce}
                  onChange={handleUserSelect}
               />
            </div>
            <ReceptionPhoto
               name={selectedCondoUser?.name || ""}
               urlLogo={selectedCondoUser?.signed_url_photo?.replace("[:STORAGE_ADDRESS:]", window.location.hostname) || ""}
            />
            {userPresence && (
               <p className='mt-2.5! mb-3! text-center'>
                  Está{`${userPresence.text !== 'Ausente' ? ' em ' : ' '}`}
                  <span className={`user-presence-text ${userPresence.text === 'Ausente' ? 'absent' : 'present'}`}>{userPresence.text}</span>
                  {userPresence.date && (
                     <span>
                        {` `}há {formatRelativeDate(new Date(), userPresence.date, { simple: true, minDays: false })}{` `}
                        <span className='opacity-40'>({formatDate(userPresence.date, { simple: true, minDays: false })})</span>
                     </span>
                  )}
               </p>
            )}
            <div className='modal-buttons-container'>

            </div>
         </ModalComponent>
      </>
   );
};

export default SearchCondoUser;